// One copy for the two journeys and the setup drawer. The journeys kept a file
// each, identical but for a dash, and the drawer asking the same question of the
// same endpoint would have made a third.
export const CHECKING = 'checking'
export const PROPAGATING = 'propagating'
export const LIVE = 'live'
export const UNKNOWN = 'unknown'

export const POLL_MS = 2000
export const MAX_POLL_MS = 180000

const SERVER_STATES = [LIVE, PROPAGATING, UNKNOWN]

// An unrecognised or missing state means the backend could not tell us, which
// must never hold the merchant back - treat it exactly as unknown.
export function normalizeState(payload) {
  const state = payload && payload.state
  return SERVER_STATES.includes(state) ? state : UNKNOWN
}

export function isSettled(state) {
  return state === LIVE || state === UNKNOWN
}

// Only open the storefront when we know the domain resolves, or when we cannot
// tell. While it is propagating the link would land on a certificate warning.
export function isLinkable(state) {
  return state === LIVE || state === UNKNOWN
}

export function domainHost(payload, handle) {
  const host = payload && payload.host
  if (host) return host
  return handle ? `${handle}.bottle.com` : ''
}

// The host is not always <handle>.bottle.com - staging puts its own label in
// front - so the parts are split off the real host rather than composed from the
// handle and a literal suffix, which printed a production address under a link
// that correctly pointed somewhere else.
export function domainHostParts(payload, handle) {
  const host = domainHost(payload, handle)
  const name = String(handle === null || handle === undefined ? '' : handle)
  const at = name ? host.indexOf(name) : -1
  if (at === -1) return { before: '', handle: host, after: '' }
  return { before: host.slice(0, at), handle: name, after: host.slice(at + name.length) }
}

export function domainUrl(payload, handle) {
  const url = payload && payload.url
  if (url) return url
  const host = domainHost(payload, handle)
  return host ? `https://${host}` : ''
}
